/*
 * Created Date: Tuesday November 9th 2021
 * Author: Oskar Karnblad
 * License: Proprietary to Scaffcalc AB
 *
 * Copyright (c) 2022 Scaffcalc AB
 */
import { DataGrid, GRID_DEFAULT_LOCALE_TEXT } from "@mui/x-data-grid";

export interface CustomDatagridExperimentalProps {
  rows: any[];
  columns: any[];
  onRowClick?: any;
  onRowDoubleClick?: any;
  localeText?: any;
  style?: any;
  gridRef: any;
}

const CustomDatagridExperimental = ({
  rows,
  columns,
  onRowClick,
  onRowDoubleClick,
  localeText,
  style,
  gridRef,
}: CustomDatagridExperimentalProps) => {
  return (
    <DataGrid
      apiRef={gridRef}
      localeText={{ ...GRID_DEFAULT_LOCALE_TEXT, ...localeText }}
      columns={columns}
      hideFooterSelectedRowCount
      onCellDoubleClick={onRowDoubleClick}
      pagination
      rows={rows}
      sx={{
        "& .MuiDataGrid-virtualScroller": {
          overflow: "auto",
          "&::-webkit-scrollbar": {
            webkitAppearance: "none",
            width: "4px",
          },
          "&::-webkit-scrollbar:horizontal": {
            webkitAppearance: "none",
            height: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            borderRadius: "2px",
            backgroundColor: "text.icon",
          },
          "&::-webkit-scrollbar-corner": {
            webkitAppearance: "none",
          },
        },
        border: "none",
        "& .MuiDataGrid-withBorderColor": {
          borderColor: "divider",
        },
        "& .MuiDataGrid-cell:focus-within, .MuiDataGrid-columnHeader:focus-within":
          {
            outline: "none !important",
          },
        ...style,
      }}
    />
  );
};

export default CustomDatagridExperimental;
